import type { RootOptions } from 'react-dom/client';
import { captureClientException } from '../shared/capture-client-exception';

/**
 * Pass to createRoot / hydrateRoot so React 19 reports uncaught and recoverable errors
 * with component stacks, in addition to default Sentry global handlers.
 */
export function getReactRootSentryOptions(): RootOptions {
  return {
    onUncaughtError: (error, errorInfo) => {
      captureClientException(error, {
        tags: { 'react.root': 'onUncaughtError' },
        extra: { componentStack: errorInfo.componentStack },
      });
    },
    onRecoverableError: (error, errorInfo) => {
      captureClientException(error, {
        tags: { 'react.root': 'onRecoverableError' },
        extra: {
          componentStack: errorInfo.componentStack,
          digest: errorInfo.digest,
        },
      });
    },
  };
}
